export default __webpack_public_path__ + "static/media/github.0e8ddfe9.svg";